export const OFFSET_STRENGTH = {
    DEFAULT: 0.05,
    HIGH: 0.1,
    LOW: 0.025,
} as const;
